import { PermissionEnum } from '@Application/Security/Roles';
import type { NavigationSection } from '@UI/Routing/navigationSection';

export type FacilitySectionPath =
	| '/facilities'
	| '/facilities/staff-members'
	| '/facilities/ai-assignments'
	| '/facilities/document-templates';

/**
 * Ordered catalogue of the delivered Agences-section screens. Every permission here is a *read*
 * permission: the section exists precisely because each list is consultable by everyone, not just
 * those who can act on it (D-13) — an administration screen is a screen that acts, none of this one
 * is. `/facilities/ai-assignments` is gated on `AI_ASSIGNMENT_READ`, the same read permission its
 * controller requires server-side (`core.md` §7): affectation is a single object across its three
 * levels (compte, organisation, agence), so its read permission is shared by all three screens.
 *
 * The first entry is also the section's entry point: `/facilities` renders the agency list directly
 * rather than redirecting to it. Its route therefore guards on the union of every permission in this
 * catalogue, not on its own `FACILITY_READ` alone — the catalogue permission below still governs its
 * tab.
 */
const FACILITY_SECTIONS: readonly NavigationSection<FacilitySectionPath>[] = [
	{
		path: '/facilities',
		label: 'Agences',
		permission: PermissionEnum.FACILITY_READ,
		action: 'consulter les agences',
	},
	{
		path: '/facilities/staff-members',
		label: 'Personnel',
		permission: PermissionEnum.STAFF_READ,
		action: 'consulter le personnel',
	},
	{
		path: '/facilities/ai-assignments',
		label: "Modèles de l'agence",
		permission: PermissionEnum.AI_ASSIGNMENT_READ,
		action: "consulter les modèles IA de l'agence",
	},
	{
		path: '/facilities/document-templates',
		label: "Gabarits de l'agence",
		permission: PermissionEnum.DOCUMENT_TEMPLATE_READ,
		action: "consulter les gabarits de l'agence",
	},
];

export default FACILITY_SECTIONS;
